import React, { useEffect, useReducer, useState, useRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MenuList } from "./Menu";

const reducer = (prev, next) => ({ ...prev, ...next });

const initialState = {
  active: "",
  activeSubmenu: "",
  selectedMainMenu: null,
};

const SideBar = () => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const role = user?.user?.role || "superadmin";
  const businessId = localStorage.getItem("business_id");
  const navigate = useNavigate();

  let menuItems = [...(MenuList[role] || [])];
  menuItems = menuItems.filter((item) => item.title !== "Menu");
  if (businessId === "4") {
    menuItems.push({
      title: "Menu",
      iconStyle: <i className="fas fa-utensils"></i>,
      to: "menu-master",
    });
  }

  const [state, setState] = useReducer(reducer, initialState);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const sidebarRef = useRef(null);
  const secondaryRef = useRef(null);

  const handleMainMenuClick = (menuTitle) => {
    const newSelected = menuTitle === state.selectedMainMenu ? null : menuTitle;
    setState({ selectedMainMenu: newSelected });
    setIsSidebarOpen(!!newSelected);
  };

  const handleSubmenuActive = (status) => {
    setState({
      activeSubmenu: state.activeSubmenu === status ? "" : status,
    });
  };

  const handleProfileClick = () => {
    if (role === "shopadmin" || role === "shopmanager") {
      navigate("/shop-vendor-profile");
    } else if (role === "cityadmin" || role === "citymanager") {
      navigate("/city-admin-profile");
    }
  };

  const handleLogout = () => {
  localStorage.clear();
  window.location.replace("/warehouse/login");  
};


  useEffect(() => {
    const main = document.getElementById("main-wrapper");
    if (main) {
      main.classList.toggle("sidebar-expanded", isSidebarOpen);
    }
    return () => {
      if (main) main.classList.remove("sidebar-expanded");
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      const target = e.target;
      if (sidebarRef.current && sidebarRef.current.contains(target)) {
        return;
      }
      if (secondaryRef.current && secondaryRef.current.contains(target)) {
        return;
      }
      setIsSidebarOpen(false);
      setState({ selectedMainMenu: null });
    };

    document.addEventListener("click", handleDocumentClick);
    return () => document.removeEventListener("click", handleDocumentClick);
  }, []);

  const path = window.location.pathname;
  const hideSidebar = location.pathname === "/pos";
  if (hideSidebar) return null;

  return (
    <>
      {/* LEFT ICON SIDEBAR */}
      <div className="veezo-sidebar" ref={sidebarRef}>
        <PerfectScrollbar className="veezo-icon-scroll">
          <ul className="veezo-icon-menu">
            {menuItems.map((data, index) => (
              <li
                key={index}
                className={`veezo-icon-item ${
                  state.selectedMainMenu === data.title ? "active" : ""
                }`}
                onClick={() => handleMainMenuClick(data.title)}
                title={data.title}
              >
                <div className="veezo-icon">{data.iconStyle}</div>
                <span className="veezo-label">{data.title}</span>
              </li>
            ))}
            {/* Profile Icon */}
            <li
              className="veezo-icon-item"
              onClick={handleProfileClick}
              title="Profile"
              style={{ marginTop: 'auto', borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '8px' }}
            >
              <div className="veezo-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
              <span className="veezo-label">Profile</span>
            </li>
            {/* Logout Icon */}
            <li
              className="veezo-icon-item"
              onClick={handleLogout}
              title="Logout"
            >
              <div className="veezo-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </div>
              <span className="veezo-label">Logout</span>
            </li>
          </ul>
        </PerfectScrollbar>
      </div>

      {/* SECONDARY EXPANDING SIDEBAR */}
      <div
        className={`veezo-secondary ${isSidebarOpen ? "show" : ""}`}
        ref={secondaryRef}
      >
        <div className="veezo-secondary-header">
          <h5>Royal-DigiPOS</h5>
        </div>

        <PerfectScrollbar className="veezo-scroll">
          {state.selectedMainMenu && (
            <>
              <div className="veezo-sub-header">
                <h6>{state.selectedMainMenu}</h6>
              </div>
              <ul className="veezo-menu">
                {menuItems
                  .filter((item) => item.title === state.selectedMainMenu)
                  .map((data, index) =>
                    data.content?.length > 0 ? (
                      data.content.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          className={`${
                            state.activeSubmenu === subItem.title
                              ? "mm-active"
                              : ""
                          }`}
                        >
                          {subItem.content && subItem.content.length > 0 ? (
                            <>
                              <Link
                                to={subItem.to}
                                className={subItem.hasMenu ? "has-arrow" : ""}
                                onClick={() =>
                                  handleSubmenuActive(subItem.title)
                                }
                              >
                                <span>{subItem.title}</span>
                                <i
                                  className={`fas fa-chevron-down submenu-caret ${
                                    state.activeSubmenu === subItem.title
                                      ? "open"
                                      : ""
                                  }`}
                                ></i>
                              </Link>
                              <Collapse in={state.activeSubmenu === subItem.title}>
                                <ul>
                                  {subItem.content.map((innerItem, innerIndex) => (
                                    <li key={innerIndex}>
                                      <Link
                                        className={`${
                                          path === innerItem.to ? "mm-active" : ""
                                        }`}
                                        to={innerItem.to}
                                      >
                                        {innerItem.title}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </Collapse>
                            </>
                          ) : (
                            <Link to={subItem.to}>
                              <span>{subItem.title}</span>
                            </Link>
                          )}
                        </li>
                      ))
                    ) : (
                      <li key={index}>
                        <Link to={data.to}>
                          <span>{data.title}</span>
                        </Link>
                      </li>
                    )
                  )}
              </ul>
            </>
          )}
        </PerfectScrollbar>
      </div>

      <style jsx>{`
        /* LEFT ICON SIDEBAR */
        .veezo-sidebar {
          position: fixed;
          top: 50px;
          left: 0;
          width: 70px;
          height: calc(100vh - 50px);
         background: linear-gradient(180deg, #BA0F30 0%, #8A0B24 100%);
         box-shadow: 2px 0 8px rgba(186, 15, 48, 0.25);
          z-index: 1000;
          display: flex;
          flex-direction: column;
        }

        .veezo-icon-scroll {
          width: 100%;
          flex-grow: 1;
          padding: 8px 0;
          overflow-y: auto;
        }
        
        .veezo-icon-scroll::-webkit-scrollbar {
          width: 3px;
        }

        .veezo-icon-scroll::-webkit-scrollbar-track {
          background: transparent;
        }

        .veezo-icon-scroll::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }

        .veezo-icon-menu {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .veezo-icon-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 12px 6px;
          color: rgba(255, 255, 255, 0.75);
          font-size: 18px;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
          margin: 3px 5px;
          border-radius: 6px;
        }

        .veezo-icon-item:hover {
          background: rgba(255, 255, 255, 0.15);
          color: #ffffff;
        }

        .veezo-icon-item.active {
          background: rgba(255, 255, 255, 0.2);
          color: #ffffff;
        }

        .veezo-icon-item.active::before {
          content: '';
          position: absolute;
          left: -5px;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 30px;
          background: #ffffff;
          border-radius: 0 3px 3px 0;
        }

        .veezo-icon {
          font-size: 20px;
          margin-bottom: 4px;
        }

        .veezo-label {
          font-size: 8px;
          text-transform: uppercase;
          font-weight: 600;
          letter-spacing: 0.3px;
          margin-top: 2px;
        }

        /* SECONDARY SIDEBAR */
        .veezo-secondary {
          position: fixed;
          top: 0;
          left: 70px;
          width: 0;
          height: 100vh;
          background: #ffffff;
          overflow: hidden;
          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.06);
          transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 999;
          border-right: 1px solid #e5e7eb;
        }

        .veezo-secondary.show {
          width: 260px;
        }

        .veezo-secondary-header {
          background: linear-gradient(180deg, #BA0F30 0%, #8A0B24 100%);
          padding: 18px 20px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          position: sticky;
          top: 0;
          z-index: 10;
        }

        .veezo-secondary-header h5 {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          color: #ffffff;
        }

        .veezo-scroll {
          height: calc(100vh - 64px);
          overflow-y: auto;
        }

        .veezo-scroll::-webkit-scrollbar {
          width: 5px;
        }

        .veezo-scroll::-webkit-scrollbar-track {
          background: transparent;
        }

        .veezo-scroll::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 10px;
        }

        .veezo-sub-header {
          background: #f9fafb;
          padding: 12px 20px;
          border-bottom: 1px solid #e5e7eb;
        }

        .veezo-sub-header h6 {
          font-size: 12px;
          color: #6b7280;
          margin: 0;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .veezo-menu {
          list-style: none;
          padding: 6px 10px;
          margin: 0;
        }

        .veezo-menu li a {
          display: flex;
          align-items: center;
          padding: 10px 12px;
          font-size: 13px;
          color: #4b5563;
          text-decoration: none;
          transition: all 0.2s ease;
          border-radius: 5px;
          font-weight: 500;
        }

        .veezo-menu li a:hover {
          background: #f3f4f6;
          color: #1a1d29;
        }

        .submenu-caret {
          margin-left: auto;
          transition: transform 0.2s ease;
          font-size: 11px;
          color: #6b7280;
        }

        .submenu-caret.open {
          transform: rotate(180deg);
          color: #BA0F30;
        }

        .veezo-menu li.mm-active > a {
          background: #e6f9ef;
          font-weight: 600;
          color: #BA0F30;
        }

        .veezo-menu li ul {
          list-style: none;
          padding: 3px 0 3px 16px;
          margin: 3px 0 0 0;
        }

        .veezo-menu li ul li a {
          padding: 8px 10px;
          font-size: 12px;
        }

        @media (max-width: 768px) {
          .veezo-sidebar {
            width: 65px;
          }
          .veezo-secondary.show {
            width: 240px;
          }
        }
      `}</style>
    </>
  );
};

export default SideBar;